//* 답례품 단가표 페이지 전용 atom

import { atom } from 'recoil';

import { QueryStatus } from 'react-query';

import { PriceTableResponse } from './priceTable.interface';

export const giftPriceTableStatusAtom = atom<QueryStatus>({
  key: 'giftPriceTableStatusAtom',
  default: 'idle',
});

export const giftPriceTableDataAtom = atom<PriceTableResponse | null>({
  key: 'giftPriceTableDataAtom',
  default: null,
});
